import React, { useMemo } from "react";

import { useStockPageData } from "./hooks/useStockPageData";
import { StockPageContext } from "./StockPageContext";
import type { StockPageContextValue, StockPageProviderProps } from "./types";

export function StockPageProvider({
  market,
  ticker,
  active,
  children
}: StockPageProviderProps) {
  const {
    pageData,
    stock,
    financialSituation,
    hasMediaMonitor,
    priceAlerts,
    stockTags,
    recommendations,
    hasMoreRecommendations,
    moreRecommendationsLoading,
    loadMoreRecommendations,
    loadFinancialSituation,
    reloadPriceAlerts,
    reloadTags
  } = useStockPageData({ market, ticker, active });

  const value = useMemo<StockPageContextValue>(
    () => ({
      market,
      ticker,
      active,
      stockId: stock.data?.stock?.id ?? null,
      stockName: stock.data?.stock?.name ?? null,
      pageData,
      stock,
      financialSituation,
      hasMediaMonitor,
      priceAlerts,
      stockTags,
      recommendations,
      hasMoreRecommendations,
      moreRecommendationsLoading,
      loadMoreRecommendations,
      loadFinancialSituation,
      reloadPriceAlerts,
      reloadTags
    }),
    [
      active,
      financialSituation,
      hasMediaMonitor,
      hasMoreRecommendations,
      loadFinancialSituation,
      loadMoreRecommendations,
      market,
      moreRecommendationsLoading,
      pageData,
      priceAlerts,
      recommendations,
      reloadPriceAlerts,
      reloadTags,
      stock,
      stockTags,
      ticker
    ]
  );

  return (
    <StockPageContext.Provider value={value}>
      {children}
    </StockPageContext.Provider>
  );
}

export default StockPageProvider;
